module.exports = __webpack_public_path__ + "static/media/limpieza.27a84d85.png";